import React from "react";
import { useSite } from "../lib/SiteContext";

const WhatsAppFloat = () => {
  const { content } = useSite();
  const wa = content?.contact?.whatsapp || "+35677000000";
  const cleaned = wa.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${cleaned}?text=${encodeURIComponent(
    "Hi Islands Escape! I'd like to know more about your charters."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 rounded-full bg-[#25D366] text-white p-4 shadow-lg hover:scale-105 transition-transform"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
    >
      <svg width="26" height="26" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.003 3.2c-7.07 0-12.8 5.73-12.8 12.797 0 2.255.59 4.46 1.71 6.404L3.2 28.8l6.59-1.728a12.78 12.78 0 0 0 6.21 1.59h.005c7.066 0 12.797-5.73 12.797-12.798 0-3.42-1.332-6.633-3.748-9.05A12.71 12.71 0 0 0 16.003 3.2zm0 23.43h-.004a10.62 10.62 0 0 1-5.413-1.482l-.388-.23-3.91 1.025 1.043-3.81-.253-.4a10.6 10.6 0 0 1-1.624-5.633c0-5.864 4.77-10.633 10.638-10.633 2.84 0 5.51 1.107 7.518 3.117a10.55 10.55 0 0 1 3.115 7.52c0 5.864-4.77 10.633-10.722 10.633zm5.83-7.962c-.32-.16-1.892-.934-2.184-1.04-.293-.107-.506-.16-.72.16-.213.32-.825 1.04-1.012 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.572-1.587-.951-.847-1.594-1.894-1.78-2.214-.187-.32-.02-.493.14-.652.144-.144.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.733-.987-2.373-.26-.624-.524-.539-.72-.55-.187-.01-.4-.012-.613-.012a1.18 1.18 0 0 0-.853.4c-.293.32-1.118 1.093-1.118 2.666 0 1.574 1.144 3.094 1.304 3.307.16.213 2.252 3.44 5.456 4.823.762.33 1.357.527 1.82.674.765.243 1.46.21 2.01.127.613-.092 1.892-.773 2.16-1.52.267-.748.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z"/>
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
